export default "__VITE_ASSET__CvB8$xqj__"